import { useEffect, useState } from "react";
import { Col, Form, Modal, Row, Select, Space } from "antd";
import { toastError, toastSuccess } from "helpers/toasters";
import { getJobTypeApi, updateSalesJobTypeApi } from "Network";

import PrimaryButton from "../SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "../SubComponents/Buttons/SecondaryButton";

const EditJobTypeModal = ({ open, rowData, SubHeader, onCancel, onSubmit }) => {
  const [jobTypes, setJobTypes] = useState([]);
  const [isLoadingTypes, setIsLoadingTypes] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setIsLoadingTypes(true);
    getJobTypeApi(
      (res) => {
        setIsLoadingTypes(false);
        if (res.success) {
          const options = (res.data || []).map((jobType) => ({
            value: jobType.id,
            label: jobType.name,
          }));
          setJobTypes(options);
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        setIsLoadingTypes(false);
        toastError(res?.message || res?.data?.error);
      },
    );
  }, []);

  useEffect(() => {
    if (rowData?.jobTypeId) {
      form.setFieldsValue({ jobTypeId: rowData.jobTypeId });
    } else {
      form.resetFields();
    }
  }, [rowData, form]);

  const handleFinish = (values) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const payload = {
      id: rowData.id,
      jobTypeId: values.jobTypeId,
    };

    updateSalesJobTypeApi(
      payload,
      (res) => {
        setIsSubmitting(false);
        if (res.success) {
          toastSuccess(res.message);
          onSubmit();
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        setIsSubmitting(false);
        toastError(res?.message || res?.data?.error);
      },
    );
  };

  return (
    <Modal
      title={SubHeader}
      open={open}
      className="msg-modal"
      footer={false}
      closable={false}
      centered
      destroyOnClose
    >
      <Form form={form} onFinish={handleFinish}>
        <Row gutter={24}>
          <Col span={24}>
            <div className="new-actor__name new-category mb-5">
              <label className="users__parent-info-label mb-2">Job Type</label>
              <Form.Item
                name="jobTypeId"
                className="new-category__form-item"
                rules={[
                  {
                    required: true,
                    message: "Please, select the job type",
                  },
                ]}
              >
                <Select
                  className="new-category__form-item auction-modal__select-holder"
                  placeholder="Select Job Type"
                  loading={isLoadingTypes}
                  options={jobTypes}
                  getPopupContainer={(trigger) => trigger.parentElement}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row className="mrg-ys-20 mrg-x-auto justify-content-center">
          <Space size={20}>
            <SecondaryButton buttonName="Cancel" onClick={onCancel} />
            <PrimaryButton
              type="submit"
              loading={isSubmitting}
              buttonName="Save"
            />
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditJobTypeModal;
